@let value = quantity() ?? 0;
<ideal-cart-stepper-input [control]="control" [(quantity)]="quantity" [label]="label()">
  @if (sellMultipleHints()) {
    @let multiplesOf = soldInMultiplesOf();
    @if (isUpdating()) {
      <mat-hint class="updating-hint">Updating Cart...</mat-hint>
    } @else if (multiplesOf > 1 && value === 0) {
      <!-- prettier-ignore -->
      <mat-hint class="multiples-hint" i18n="@@cart.multiples-hint">
    Sold in multiples of {multiplesOf, plural,
    =1 { {{ multiplesOf | i18nPlural: displayUnitLabel() }}}
    other { {{ multiplesOf | number }} {{ multiplesOf | i18nPlural: displayUnitLabel() }}}
    }
  </mat-hint>
    } @else if (multiplesOf > 1 && value > 0) {
      <mat-hint class="multiples-hint" i18n="@@cart.simple-quantity-calc-hint"
        ><span value>{{ value | number }}</span> x <span multiples>{{ multiplesOf | number }}</span> =
        <span total>{{ value * multiplesOf | number }}</span>
        <!-- prettier-ignore -->
        <span>
      {{ multiplesOf | i18nPlural: displayUnitLabel() }}
    </span>
      </mat-hint>
    }
  }
</ideal-cart-stepper-input>
